import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'interacta-ai-panel-layout',
    template: `
        <section class="rag-gradient-rounded-border">
            <div class="content flex flex-col bg-surface-A">
                <ng-content />
            </div>
        </section>
    `,
    styles: `
        @reference '@interacta-shared/ui/reference.css';

        .rag-gradient-rounded-border {
            @apply relative size-full rounded-3xl p-1;
            background-image: linear-gradient(
                165deg,
                var(--in-color-ai-primary) 2.84%,
                var(--in-color-ai-secondary) 61.22%
            );
            background-origin: border-box;
            background-clip: border-box;
            box-sizing: border-box;
        }

        .rag-gradient-rounded-border .content {
            @apply absolute inset-1;
            border-radius: calc(24px - 1px);
            box-sizing: border-box;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AIPanelLayoutComponent {}
